// export const base_url = 'http://localhost:2000/api/'
export const base_url ='https://backend.nationalpaints.co.in/api/'

